import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { Row, Col } from "reactstrap";
import { Helmet } from "react-helmet";
import axios from "axios";
import moment from "moment";

import Title from "../../components/general/AdminPageTitle/AdminPageTitle";
import ActionButtons from "../../components/page/advertise/ActionButtons/ActionButtons";
import TruckCount from "../../components/general/Count/Count";
import Table from "../../components/general/Table/Table";
import Loading from "../../components/wrapper/Loading/Loading";
import polyline from "@mapbox/polyline";
import DataTable from "../../components/general/DataTable/DataTable";
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';

import classes from './DrivePage.module.scss';
import { boxiPrimary } from "../../assets/style/colors";

const campaignNameComparator = (a, b) => {
  let first = a[1].toUpperCase();
  let second = b[1].toUpperCase();
  return (first === "") - (second === "") || +(first > second) || -(first < second);
};

// const encodedPolyline = ''
// const coordinates = []
// polyline.decode(encodedPolyline).map((point) => coordinates.push(point.reverse()));
// console.log(coordinates);

// console.log(moment('2023-06-22').startOf('day').utc().unix() * 1000)
// console.log(moment('2023-06-22').endOf('day').utc().unix() * 1000)

class AdvertisePage extends Component {
  state = {
    activeCampaignsData: [],
    expiredCampaignsData: [],
    inProductionCampaignsData: [],
    truckCount: 0,
    isLoading: false,
    activeTab: 0,

    // active campaigns data table states
    activeColumns: [
      { width: 20, field: 'id', headerName: '#', sortable: false },
      { flex: 3, field: 'campaign_name', headerName: 'Campaign Name' },
      { flex: 1, field: 'num_active_trucks', headerName: 'Active Trucks' },
      { flex: 1, field: 'num_inactive_trucks', headerName: 'Inactive Trucks' },
      { flex: 1, field: 'num_placeholders', headerName: 'Rep Routes' },
      { flex: 1, field: 'num_macros', headerName: 'Macros' },
      { flex: 1, field: 'days_elapsed', headerName: 'Days Elapsed', sortable: false },
      { flex: 1, field: 'days_remaining', headerName: 'Days Remaining', sortable: false },
      { width: 30, field: 'btn', headerName: '', sortable: false, renderCell: (params) => {
        return (
          <EditIcon onClick={() => this.props.history.push(`/dashboard/admin/advertise/campaign/edit/${params.row.campaign_id}`)} style={{ color: boxiPrimary, cursor: 'pointer' }}>
          </EditIcon>
        );
      } }
    ],
    activeRows: [],
    activeCampaignsParams: {
      sortOrder: 'asc',
      sortBy: 'campaign_name',
      page: 0,
      pageSize: 10,
      search: null
    },
    isActiveCampaignsLoading: false,
    totalActiveCampaigns: 0,

    // expired campaigns data table states
    expiredColumns: [
      { width: 20, field: 'id', headerName: '#', sortable: false },
      { flex: 3, field: 'campaign_name', headerName: 'Campaign Name' },
      { flex: 1, field: 'num_inactive_trucks', headerName: 'Trucks' },
      { flex: 1, field: 'start_date', headerName: 'Start Date' },
      { flex: 1, field: 'end_date', headerName: 'End Date' },
      { width: 30, field: 'btn', headerName: '', sortable: false, renderCell: (params) => {
        return (
          <EditIcon onClick={() => this.props.history.push(`/dashboard/admin/advertise/campaign/edit/${params.row.campaign_id}`)} style={{ color: boxiPrimary, cursor: 'pointer' }}>
          </EditIcon>
        );
      } }
    ],
    expiredRows: [],
    expiredCampaignsParams: {
      sortOrder: 'asc',
      sortBy: 'campaign_name',
      page: 0,
      pageSize: 10,
      search: null
    },
    isExpiredCampaignsLoading: false,
    totalExpiredCampaigns: 0,

    // in production campaigns data table states
    inProductionColumns: [
      { width: 20, field: 'id', headerName: '#', sortable: false },
      { flex: 3, field: 'campaign_name', headerName: 'Campaign Name' },
      { flex: 1, field: 'num_inactive_trucks', headerName: 'Trucks' },
      { flex: 1, field: 'start_date', headerName: 'Start Date' },
      { flex: 1, field: 'end_date', headerName: 'End Date' },
      { width: 30, field: 'btn', headerName: '', sortable: false, renderCell: (params) => {
        return (
          <EditIcon onClick={() => this.props.history.push(`/dashboard/admin/advertise/campaign/edit/${params.row.campaign_id}`)} style={{ color: boxiPrimary, cursor: 'pointer' }}>
          </EditIcon>
        );
      } }
    ],
    inProductionRows: [],
    inProductionCampaignsParams: {
      sortOrder: 'asc',
      sortBy: 'campaign_name',
      page: 0,
      pageSize: 10,
      search: null
    },
    isInProductionCampaignsLoading: false,
    totalInProductionCampaigns: 0
  };

  getActiveCampaigns = (sortOrder, sortBy, page, pageSize, search) => {
    const params = {
      sortOrder, 
      sortBy, 
      page, 
      pageSize,
      search
    }

    this.setState({
      activeCampaignsParams: params,
      isActiveCampaignsLoading: true
    })

    axios.get(`${process.env.REACT_APP_API_HOST}/active-campaigns`, {params}).then((res) => {
      if (res.status === 200) {
        console.log(res.data);
        const activeRows = [];
        res.data.active_campaigns.map((campaign, index) => {
          activeRows.push({
            id: (page * pageSize) + index + 1,
            campaign_id: campaign.campaign_id,
            campaign_name: campaign.campaign_name,
            num_active_trucks: campaign.num_active_trucks,
            num_inactive_trucks: campaign.num_inactive_trucks,
            num_placeholders: campaign.num_placeholders,
            num_macros: campaign.num_macros,
            days_elapsed: Math.ceil(Math.abs(new Date() - new Date(campaign.start_date)) / (1000 * 60 * 60 * 24)),
            days_remaining: Math.ceil(Math.abs(new Date(campaign.end_date) - new Date()) / (1000 * 60 * 60 * 24))
          })
        });
        this.setState({
          activeRows: activeRows,
          isActiveCampaignsLoading: false,
          totalActiveCampaigns: res.data.rowCount
        })
      }
    })
  }

  getInProductionCampaigns = (sortOrder, sortBy, page, pageSize, search) => {
    const params = {
      sortOrder, 
      sortBy, 
      page, 
      pageSize,
      search
    }

    this.setState({
      inProductionCampaignsParams: params,
      isInProductionCampaignsLoading: true
    })

    axios.get(`${process.env.REACT_APP_API_HOST}/in-production-campaigns`, {params}).then((res) => {
      if (res.status === 200) {
        console.log(res.data);
        const inProductionRows = [];
        res.data.in_production_campaigns.map((campaign, index) => {
          inProductionRows.push({
            id: (page * pageSize) + index + 1,
            campaign_id: campaign.campaign_id,
            campaign_name: campaign.campaign_name,
            num_inactive_trucks: campaign.num_inactive_trucks,
            start_date: moment(campaign.start_date).utc().format("YYYY-MM-DD"),
            end_date: moment(campaign.end_date).utc().format("YYYY-MM-DD")
          })
        });
        this.setState({
          inProductionRows: inProductionRows,
          isInProductionCampaignsLoading: false,
          totalInProductionCampaigns: res.data.rowCount
        })
      }
    })
  }

  getExpiredCampaigns = (sortOrder, sortBy, page, pageSize, search) => {
    const params = {
      sortOrder, 
      sortBy, 
      page, 
      pageSize,
      search
    }

    this.setState({
      expiredCampaignsParams: params,
      isExpiredCampaignsLoading: true
    })

    axios.get(`${process.env.REACT_APP_API_HOST}/expired-campaigns`, {params}).then((res) => {
      if (res.status === 200) {
        console.log(res.data);
        const expiredRows = [];
        res.data.expired_campaigns.map((campaign, index) => {
          expiredRows.push({
            id: (page * pageSize) + index + 1,
            campaign_id: campaign.campaign_id,
            campaign_name: campaign.campaign_name,
            num_inactive_trucks: campaign.num_inactive_trucks,
            start_date: moment(campaign.start_date).utc().format("YYYY-MM-DD"),
            end_date: moment(campaign.end_date).utc().format("YYYY-MM-DD")
          })
        });
        this.setState({
          expiredRows: expiredRows,
          isExpiredCampaignsLoading: false,
          totalExpiredCampaigns: res.data.rowCount
        })
      }
    })
  }

  componentDidMount = () => {
    this.setState({
      isLoading: true
    })

    this.getActiveCampaigns('asc', 'campaign_name', 0, 10, null);

    // axios
    //   .get(`${process.env.REACT_APP_API_HOST}/campaign`, { withCredentials: true })
    //   .then((res) => {
    //     if (res.status === 200) {
    //       let count = 0;

    //       let inProductionCampaigns = res.data.in_production_campaigns.map((campaign) => {
    //         return [
    //           campaign.campaign_id,
    //           campaign.name,
    //           parseInt(campaign.num_active_trucks) + parseInt(campaign.num_inactive_trucks),
    //           moment(campaign.start_date).utc().format("YYYY-MM-DD"),
    //           moment(campaign.end_date).utc().format("YYYY-MM-DD")
    //         ];
    //       });

    //       // sort campaigns by name alphabetically ascending
    //       inProductionCampaigns = inProductionCampaigns.sort(campaignNameComparator);

    //       this.setState({
    //         inProductionCampaignsData: inProductionCampaigns,
    //         // truckCount: count,
    //         isLoading: false
    //       });
    //     }
    //   })
    //   .catch((err) => console.log(err));
  };

  selectTab = (index) => {
    if (index === 0) {
      this.getActiveCampaigns('asc', 'campaign_name', 0, 10, null);
    } else if (index === 1) {
      this.getInProductionCampaigns('asc', 'campaign_name', 0, 10, null);
    } else if (index === 2) {
      this.getExpiredCampaigns('asc', 'campaign_name', 0, 10, null);
    }
    this.setState({
      activeTab: index
    })
    setTimeout(() => {
      index === 1 && window.dispatchEvent(new Event('resize'));
    }, 1);
  }

  render() {
    let activeCampaignsHeaders = [
      "id",
      "Campaign Name",
      "Active Trucks",
      "Inactive Trucks",
      "Rep Routes",
      "Macros",
      "Days Remaining",
      "Days Elapsed"
    ];
    let activeCampaignTableButtons = [
      {
        display: "Edit",
        // path: "/dashboard/admin/advertise/campaign/edit"
        onClickHandler: (index, id) => {
          this.props.history.push(`/dashboard/admin/advertise/campaign/edit/${id}`);
        }
      }
    ];

    let expiredCampaignsHeaders = ["id", "Campaign Name", "Trucks", "Start Date", "End Date"];
    let expiredCampaignTableButtons = [
      {
        display: "Edit",
        // path: "/dashboard/admin/advertise/campaign/edit"
        onClickHandler: (index, id) => {
          this.props.history.push(`/dashboard/admin/advertise/campaign/edit/${id}`);
        }
      }
    ];

    return (
      <Fragment>
        {/* <Loading loading={this.state.isLoading} label="Loading Campaigns..." /> */}
        <Helmet>
          <title>Boxi Admin | Advertise</title>
        </Helmet>
        {/* Top row */}
        <Row className="mb-4">
          <Col xs="4">
            <Title>Advertise</Title>
          </Col>
          <Col xs="8">
            <ActionButtons />
          </Col>
          {/* <Col xs="3">
            <TruckCount count={this.state.truckCount}>
              Trucks On <br /> Campaign
            </TruckCount>
          </Col> */}
        </Row>


        <div className={classes.tabs}>
          <div onClick={() => this.selectTab(0)} className={this.state.activeTab === 0 ? classes.activeTab : classes.tab}>
            Active Campaigns
          </div>
          <div onClick={() => this.selectTab(1)} className={this.state.activeTab === 1 ? classes.activeTab : classes.tab}>
            In-Production Campaigns
          </div>
          <div onClick={() => this.selectTab(2)} className={this.state.activeTab === 2 ? classes.activeTab : classes.tab}>
            Expired Campaigns
          </div>
        </div>

        {this.state.activeTab === 0 && <Row className={`mt-4 ${this.state.activeTab === 0 ? classes.activeTable : classes.inactiveTable}`}>
          <Col>
            <DataTable
              title="Active Campaigns"
              rows={this.state.activeRows}
              columns={this.state.activeColumns}
              fetchData={this.getActiveCampaigns}
              params={this.state.activeCampaignsParams}
              isLoading={this.state.isActiveCampaignsLoading}
              rowCount={this.state.totalActiveCampaigns}
            />
          </Col>
        </Row>}
        {/* <Row className="mb-4">
          <Col>
            <Table
              id="active-campaign-table"
              title="Active Campaigns"
              buttons={activeCampaignTableButtons}
              headers={activeCampaignsHeaders}
              data={this.state.activeCampaignsData}
              colors={["#20B96F"]}
            ></Table>
          </Col>
        </Row> */}


        {this.state.activeTab === 1 && <Row className={`mt-4 ${this.state.activeTab === 1 ? classes.activeTable : classes.inactiveTable}`}>
          <Col>
            {/* <Table
              id="in-production-campaign-table"
              title="In Production Campaigns"
              buttons={expiredCampaignTableButtons}
              headers={expiredCampaignsHeaders}
              data={this.state.inProductionCampaignsData}
              colors={["#34BBCA"]}
            ></Table> */}
            <DataTable
              title="In-Production Campaigns"
              rows={this.state.inProductionRows}
              columns={this.state.inProductionColumns}
              fetchData={this.getInProductionCampaigns}
              params={this.state.inProductionCampaignsParams}
              isLoading={this.state.isInProductionCampaignsLoading}
              rowCount={this.state.totalInProductionCampaigns}
            />
          </Col>
        </Row>}
        {this.state.activeTab === 2 && <Row className={`mt-4 ${this.state.activeTab === 2 ? classes.activeTable : classes.inactiveTable}`}>
          <Col>
            {/* <Table
              id="expired-campaign-table"
              title="Expired Campaigns"
              buttons={expiredCampaignTableButtons}
              headers={expiredCampaignsHeaders}
              data={this.state.expiredCampaignsData}
              colors={["#FC575E"]}
            ></Table> */}
            <DataTable
              title="Expired Campaigns"
              rows={this.state.expiredRows}
              columns={this.state.expiredColumns}
              fetchData={this.getExpiredCampaigns}
              params={this.state.expiredCampaignsParams}
              isLoading={this.state.isExpiredCampaignsLoading}
              rowCount={this.state.totalExpiredCampaigns}
            />
          </Col>
        </Row>}
      </Fragment>
    );
  }
}

export default withRouter(AdvertisePage);
